<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-position="right" class="search-form">
                <el-form-item label="科室">
                    <el-input v-model.trim="filters.departmentName" placeholder="请输入科室名称"></el-input>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="buttonText">
                <el-button type="warning" @click="add" icon="el-icon-edit">新增</el-button>
                <el-button type="danger" @click="delAll" icon="el-icon-delete">删除</el-button>
            </div>
        </div>
        <div class="layout-page-box">
            <!-- :height="tableHeight" -->
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="id" label="id"></el-table-column>
                <el-table-column sortable prop="departmentName" label="科室名称"></el-table-column>
                <el-table-column sortable prop="createBy" label="创建人"></el-table-column>
                <el-table-column sortable prop="createTime" label="创建时间"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <!-- <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <el-dialog :title="title" v-if="dialogFormVisible" :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <el-form :model="formData" ref="formData" :rules="rules" label-width="70px">
                <el-form-item label="科室" prop="departmentName">
                    <el-input clearable v-model.trim="formData.departmentName" placeholder="请输入科室名称" style="width:95%;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
                <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "department",
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
            },
            tableData: [],
            multipleSelection: [],
            tableHeight: '',
            dialogFormVisible: false,
            formData: {},
            rules: {
                departmentName: [{ required: true, message: "请填写科室名称", trigger: "blur" }],
            },
            code: 0,
            title: '',
        }
    },
    created() {
        // this.tableHeight = document.documentElement.clientHeight - 380
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        add() {
            this.dialogFormVisible = true
            this.code = 0
            this.formData = {}
            this.title = '新增科室'
        },
        handleEdit(index, row) {
            this.dialogFormVisible = true
            this.code = 1
            this.title = '修改科室'
            this.formData = JSON.parse(JSON.stringify(row))
        },
        doAddgoods(formData) {
            this.$refs[formData].validate((valid) => {
                if (valid) {
                    this.formData.createBy = Lockr.get('skinEmpId')
                    let querys = {
                        createBy: this.formData.createBy,
                        departmentName: this.formData.departmentName,
                        id: this.formData.id,
                    }
                    if (this.code == 0) {
                        // 新增
                        api.request('/register/createDepartmentMenu', querys, (res) => {
                            if (res.result == true) {
                                this.dialogFormVisible = false
                                this.query(this.filters.pagination.page)
                                _g.toast("success", '科室新增成功！');
                            } else {
                                _g.toast("error", res.errMsg);
                            }
                        }, (err) => { });
                    } else if (this.code == 1) {
                        // 修改
                        api.request('/register/updateDepartmentMenu', querys, (res) => {
                            if (res.result == true) {
                                this.dialogFormVisible = false
                                this.query(this.filters.pagination.page)
                                _g.toast("success", '科室修改成功！');
                            } else {
                                _g.toast("error", res.errMsg);
                            }
                        }, (err) => { });
                    }


                } else {
                    _g.toast("warning", "请完善信息");
                    return false;
                }
            })
        },
        // 批量删除
        delAll() {
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                console.log(item)
                id.push(item.id);
            });
            this.$confirm("确定要删除选中的数据吗？", "删除项目", {
                center: true,
            })
                .then((res) => {
                    api.requestQuiet(
                        "/register/deleteDepartmentMenu", {
                            id: id.toString(),
                        },
                        (res) => {
                            if (res.result == true) {
                                _g.toast("success", "删除成功");
                                this.query(this.filters.pagination.page);
                            } else {
                                _g.toast("error", "删除失败");
                                this.query(this.filters.pagination.page);
                            }
                        }
                    );
                })
                .catch((err) => {
                    // this.$message.error('删除失败！');
                });
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                departmentName: this.filters.departmentName
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/register/findDepartmentMenuPage', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.next >>> .el-dialog {
  width: 90% !important;
}
.next >>> .el-dialog__header {
  padding: 0 !important;
}
</style>